module.exports = __webpack_public_path__ + "img/tow.aa96b527.jpg";